import React from "react";
import { makeStyles } from "tss-react/mui";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import TranslationWrapper, { allRenderedTranslations, exceptionsToTranslate } from "./TranslationWrapper";
import { Typography } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";

const drawerWidth = 240;

const useStyles = makeStyles()((theme) => ({
  root: {
    // display: "flex",
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(3) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(5) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
}));

function TranslationSideBar() {
  const { classes, cx } = useStyles();
  const translateExceptionsMode = JSON.parse(localStorage.getItem("translateExceptionsMode")) ?? false;
  const [open, setOpen] = React.useState(translateExceptionsMode);

  return (
    <div className={classes.root} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <Drawer
        className={cx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: cx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
        variant={"permanent"}
      >
        <div className={classes.toolbar}>
          <Typography>translate exceptions</Typography>
          <TranslateIcon />
        </div>
        <Typography align={"center"} gutterBottom variant={"body2"}>
          ***placeholders, disabled buttons, selection drop-down text, etc..)
        </Typography>
        <List>
          {exceptionsToTranslate.map((translation) => (
            <ListItem button key={translation.tKey}>
              <TranslationWrapper tDefault={translation.tDefault} tKey={translation.tKey} />
            </ListItem>
          ))}
        </List>
        <Divider />
        <div className={classes.toolbar}>
          <Typography>All rendered translations</Typography>
          <TranslateIcon />
        </div>
        <Typography align={"center"} gutterBottom variant={"body2"}>
          ***Refresh page to remove translations from previous pageLinks (Producten, verkoopgebieden, menukaarten,
          etc..)
        </Typography>
        <List>
          {allRenderedTranslations.map((translation, index) => (
            <ListItem button key={translation.tKey}>
              <TranslationWrapper tDefault={translation.tDefault} tKey={translation.tKey} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </div>
  );
}

export default TranslationSideBar;
